"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const styles_1 = require("./styles");
const EqualHeightsContext = react_1.default.createContext({
    addRef: () => ({
        current: null
    }),
    equalHeight: "auto",
    updateRef: () => {
        // no-op
    }
});
const EqualHeights = ({ children }) => {
    const [equalHeight, setEqualHeight] = (0, react_1.useState)("auto");
    const refs = (0, react_1.useRef)({});
    const setHeights = (0, react_1.useCallback)(() => {
        const offsetHeights = Object.values(refs.current)
            .map((ref) => {
            return ref.current?.clientHeight;
        })
            .filter(Boolean);
        const newEqualHeight = offsetHeights.length
            ? Math.max(...offsetHeights)
            : "auto";
        if (newEqualHeight !== equalHeight) {
            setEqualHeight(newEqualHeight);
        }
    }, [refs]);
    (0, react_1.useEffect)(() => {
        setHeights();
    }, [refs]);
    (0, react_1.useEffect)(() => {
        const windowResizeListener = () => {
            setHeights();
        };
        window.addEventListener("resize", windowResizeListener);
        return () => {
            window.removeEventListener("resize", windowResizeListener);
        };
    }, []);
    const addRef = (id) => {
        // eslint-disable-next-line security/detect-object-injection
        refs.current[id] = refs.current[id] || { current: null };
        // Safe to cast as whatever is adding the reference is going
        // to be of that type
        // eslint-disable-next-line security/detect-object-injection
        return refs.current[id];
    };
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(EqualHeightsContext.Provider, { value: { addRef, updateRef: setHeights, equalHeight }, children: children }) }));
};
const EqualHeightsConsumer = ({ children, shouldDisableBoxSizing, component: Component = "div" }) => {
    return ((0, jsx_runtime_1.jsx)(styles_1.Root, { as: Component, className: (0, classnames_1.default)(shouldDisableBoxSizing && styles_1.classes.contentBox), children: (0, jsx_runtime_1.jsx)(EqualHeightsContext.Consumer, { children: children }) }));
};
EqualHeights.Consumer = EqualHeightsConsumer;
exports.default = EqualHeights;
//# sourceMappingURL=data:application/json;base64,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